import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.button`
  font-size: 2rem;
  padding-top: 0 !important;
  text-transform: uppercase;
  background: none;
  color: #ffdf22;
  letter-spacing: 0.1rem;
  margin-bottom: 1.4rem;
  font-weight: 700;

  @media (max-width: ${breakpoints.medium}) {
    margin-left: 1.6rem;
  }
`;
